import { jsxs, jsx } from "react/jsx-runtime";
function SupportTicketStatusPart({ output }) {
  if (!output || output.status !== "ok" || !output.ticketId) return null;
  const ref = output.displayId ?? output.ticketId;
  const state = output.state ? humanizeState(output.state) : "Submitted";
  const reply = output.latestAdminReply;
  const title = output.title ?? output.ticketTypeName ?? `Ticket #${ref}`;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: "tw:my-2 tw:rounded-xl tw:border tw:border-gray-200 tw:bg-white tw:p-4 tw:shadow-sm",
      role: "group",
      "aria-label": "Support ticket status",
      children: [
        /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:items-start tw:justify-between tw:gap-3", children: [
          /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:flex-col tw:gap-1", children: [
            /* @__PURE__ */ jsxs("div", { className: "tw:flex tw:items-center tw:gap-2", children: [
              /* @__PURE__ */ jsx("span", { className: "tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wide tw:text-gray-500", children: "Ticket" }),
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: `tw:rounded-full tw:px-2 tw:py-0.5 tw:text-xs tw:font-medium ${stateClass(output.state)}`,
                  style: isDefaultState(output.state) ? defaultStateStyle : void 0,
                  children: state
                }
              )
            ] }),
            /* @__PURE__ */ jsxs("div", { className: "tw:text-base tw:font-semibold tw:text-gray-900", children: [
              "#",
              ref
            ] }),
            /* @__PURE__ */ jsx("div", { className: "tw:text-xs tw:text-gray-500", children: title })
          ] }),
          output.ticketUrl && /* @__PURE__ */ jsx(
            "a",
            {
              href: output.ticketUrl,
              target: "_blank",
              rel: "noopener noreferrer",
              className: "tw:rounded-md tw:border tw:border-gray-200 tw:bg-gray-50 tw:px-3 tw:py-1.5 tw:text-xs tw:font-semibold tw:text-gray-700 tw:no-underline hover:tw:bg-gray-100",
              children: "View"
            }
          )
        ] }),
        reply ? /* @__PURE__ */ jsxs("div", { className: "tw:mt-4 tw:rounded-lg tw:border-l-4 tw:border-gray-200 tw:bg-gray-50 tw:p-3", children: [
          /* @__PURE__ */ jsx("div", { className: "tw:text-xs tw:font-semibold tw:text-gray-700", children: reply.authorName ? `${reply.authorName} replied` : "Latest reply from support" }),
          /* @__PURE__ */ jsx("div", { className: "tw:text-xs tw:text-gray-500 tw:mb-1", children: new Date(reply.postedAt).toLocaleString() }),
          /* @__PURE__ */ jsx("div", { className: "tw:text-sm tw:text-gray-800 tw:leading-relaxed tw:whitespace-pre-wrap", children: stripHtml(reply.body) })
        ] }) : /* @__PURE__ */ jsx("p", { className: "tw:mt-3 tw:text-sm tw:text-gray-500", children: "No reply from the support team yet." })
      ]
    }
  );
}
function humanizeState(state) {
  switch (state) {
    case "submitted":
      return "Submitted";
    case "in_progress":
      return "In progress";
    case "waiting_on_customer":
      return "Waiting on you";
    case "resolved":
      return "Resolved";
    case "closed":
      return "Closed";
    default:
      return (state ?? "Submitted").replace(/_/g, " ");
  }
}
function stateClass(state) {
  switch (state) {
    case "resolved":
    case "closed":
      return "tw:bg-gray-100 tw:text-gray-600";
    case "waiting_on_customer":
      return "tw:bg-amber-50 tw:text-amber-700";
    case "in_progress":
      return "tw:bg-blue-50 tw:text-blue-700";
    default:
      return "";
  }
}
function isDefaultState(state) {
  return state !== "resolved" && state !== "closed" && state !== "waiting_on_customer" && state !== "in_progress";
}
const defaultStateStyle = {
  backgroundColor: "var(--bc-support-bg)",
  color: "var(--bc-support-text)"
};
function stripHtml(html) {
  return html.replace(/<br\s*\/?>(\n)?/gi, "\n").replace(/<\/(p|div)>/gi, "\n").replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#039;/g, "'").trim();
}
export {
  SupportTicketStatusPart
};
//# sourceMappingURL=SupportTicketStatusPart.js.map
